import {Grid, Box} from '@mui/material';
import {CatalogComponent} from '../../../../api/models';
import {TextComponent} from '../../../RetailerWebScreen/components/TextComponent';

const CatalogItem = ({item}: {item: CatalogComponent}) => {
    return (
        <Grid style={{marginBottom: 24}} item md={6} sm={12} xs={12} lg={4} xl={4}>
            <center>
                <img srcSet={item.image.url} src={item.image.url} alt={`Shop Image ${item.image.url}`} loading='lazy' />
            </center>
            <TextComponent variant='h6' content={'Price: Rs.' + item.price.text} fontWeight={300} />
            <TextComponent variant='h5' content={item.title.text} fontWeight={600} />
            <TextComponent variant='body1' content={item.subtitle.text} fontWeight={300} />
        </Grid>
    );
};

export const CatalogueItemsList = ({catalogItems}: {catalogItems: CatalogComponent[]}) => {
    const items = catalogItems;
    return (
        <Box>
            <Grid container>
                {items.map((item: CatalogComponent) => {
                    return <CatalogItem item={item} />;
                })}
            </Grid>
        </Box>
    );
};
